var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"3","viewBox":"0 0 15 3","fill":"none"}},[_c('circle',{attrs:{"cx":"7.5","cy":"1.5","r":"1.5","fill":"#5F5F5F"}}),_c('circle',{attrs:{"cx":"13.5","cy":"1.5","r":"1.5","fill":"#5F5F5F"}}),_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5","fill":"#5F5F5F"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }